import {AfterViewInit, Directive, HostListener, OnDestroy, OnInit, Self} from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {browser} from 'browser-sync/dist/default-config';

@Directive({
  standalone: true,
  selector: '[appCurrencyFormatter]'
})
export class CurrencyFormatterDirective implements OnInit, AfterViewInit, OnDestroy {

  private formatter: Intl.NumberFormat;
  private destroy$ = new Subject<void>();
  private decimalSeparator: string;
  private trailingDecimalSeparator: string = "";
  private thousandSeparator: string;
  constructor(@Self() private ngControl: NgControl) {
    this.formatter = new Intl.NumberFormat(navigator?.language || "en-US", { maximumFractionDigits: 2 });
    this.decimalSeparator = this.getDecimalSeparator();
    this.thousandSeparator = this.getThousandSeparator();
  }
  ngOnInit() {
    setTimeout(() => {
      const initialValue = this.ngControl.control?.value || '0';
      this.setValue(this.formatPrice(initialValue));
    });
    // este liteners uno pensaria que se puede quitar por el @input listener pero no , sin este no se
    // formatea inicialmente
      this.ngControl.control.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(value => this.updateValue(value));
  }

  ngAfterViewInit() {
    // Initialize with formatted value
    setTimeout(() => {
      const initialValue = this.ngControl.control?.value || '0';
      this.setValue(this.formatPrice(initialValue));
    });
  }

  updateValue(value: string | number) {
    const inputVal = String(value || '');
    const cleanedValue = this.cleanValue(inputVal);
    this.trailingDecimalSeparator = inputVal.endsWith(this.decimalSeparator) ? this.decimalSeparator : inputVal.endsWith(this.decimalSeparator+"0") ? this.decimalSeparator+"0":"";
    this.setValue(this.formatPrice(cleanedValue) + this.trailingDecimalSeparator);
  }

  // @HostListener('focus') onFocus() {
  //   const currentValue = this.ngControl.value || '';
  //   this.setRawValue(this.unformatValue(currentValue));
  // }

  // eso es necesario para formularios porque hasta que el usuario quite el campo el formularo no actualiza el ngControl, entonces el listener establecido en el nginit no funciona
  @HostListener('input') onInput() {
    const value = this.ngControl.value;
    this.updateValue(value);
  }

  @HostListener('blur') onBlur() {
    const value = this.ngControl.value || '0';
    this.setValue(this.formatPrice(value));
  }

  formatPrice(value: string): string {
    const numericValue = parseFloat(this.reformatToParseableFloat(value));
    return isNaN(numericValue) ? '' : this.formatter.format(numericValue);
  }

  reformatToParseableFloat(value: string): string {
    if (!value) return '';
    console.log("reformat to parse " + value)
    return value.replace(new RegExp('\\' + this.thousandSeparator, 'g'), '')
      .replace(new RegExp('\\' + this.decimalSeparator), '.')
  }

  cleanValue(value: string): string {
    // Remove all non-numeric characters except the decimal point
    console.log("cleanValue " + value)
    return value.replace(new RegExp(`[^0-9${this.decimalSeparator}]`, 'g'), '');
  }

  getDecimalSeparator(): string {
    // Detect the decimal separator from the formatter
    const userLocale = navigator.language || 'en-US';
    return Intl.NumberFormat(userLocale).format(1.1).replace(/\p{Number}/gu, '');
  }
  getThousandSeparator(): string {
    const userLocale = navigator.language || 'en-US';
    return Intl.NumberFormat(userLocale).format(11111).replace(/\p{Number}/gu, '');

  }

  setValue(value: string) {
    if (this.ngControl.control) {
      this.ngControl.control.setValue(value, { emitEvent: false });
    }
  }

  setRawValue(value: string) {
    if (this.ngControl.control) {
      this.ngControl.control.setValue(value, { emitEvent: false });
    }
  }

  ngOnDestroy() {
    if (this.ngControl.control) {
      this.setValue(this.formatPrice(this.reformatToParseableFloat(this.ngControl.value || '0')));
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
